import type { AlbumManifest } from "../data/manifest";
import { PageRenderer } from "../render/PageRenderer";
import { getLayout } from "../data/layouts";

/** Dev-only parity harness (?parity): every page rendered static (no scroll-
 *  snap) so geometry + crop + look can be eyeballed at once — and, later,
 *  pixel-diffed against the print master for the same album. Not part of the
 *  reader UX. */
export function ParityGrid({ manifest }: { manifest: AlbumManifest }) {
  return (
    <div style={{ padding: 24, background: "var(--ground)", minHeight: "100dvh" }}>
      <h1 style={{ fontSize: 20, marginBottom: 16 }}>Parity harness — {manifest.title}</h1>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))",
          gap: 28,
        }}
      >
        {manifest.pages.map((page) => (
          <figure key={page.index} style={{ margin: 0 }}>
            <PageRenderer page={page} photos={manifest.photos} priority />
            <figcaption
              className="label"
              style={{ marginTop: 8, textAlign: "center" }}
            >
              {page.layout} · {getLayout(page.layout)?.capacity ?? "?"} slots
              {page.look && page.look !== "none" ? ` · ${page.look}` : ""}
            </figcaption>
          </figure>
        ))}
      </div>
    </div>
  );
}
